import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { PromotionalFeatureList } from './components/promotional-feature-list';
import style from './email-marketing-handoff-modal.module.css';
import { useTrackPromoModal } from './hooks/use-track-promo-modal';
import { emailModalMesssages } from './messages';
import { ModalsToShow } from './new-lineup-promotional-migration-loader';
import StandardOrPremiumPlanFeaturesSVG from './standard-or-premium-plan-features.svg';
import { ModalPortal } from '../../../../../components/modal-portal';
import { useOnComponentMount } from '../../../../../hooks/use-on-component-mount';

/**
 * @param {object} props
 * @param {string} props.billingPlanId
 * @param {string} props.planName
 * @param {() => void} props.viewOffer
 * @param {() => void} props.onClose
 * @returns {JSX.Element}
 */
export const MigratePlanEmailMarketingHandoffModal = ({ billingPlanId, planName, viewOffer, onClose }) => {
  const intl = useIntl();
  const { trackPromoStartEvent, trackPromoContinueEvent } = useTrackPromoModal();

  useOnComponentMount(() => trackPromoStartEvent(ModalsToShow.EmailHandoff));

  const viewOfferHandler = useCallback(() => {
    viewOffer();
    trackPromoContinueEvent();
  }, [trackPromoContinueEvent, viewOffer]);

  return (
    <ModalPortal onClose={onClose}>
      <Modal size='large'>
        <ModalBody>
          <FlexRow className={style['modal-row']}>
            <FlexColumn className={style['description-section']}>
              <FlexColumn className={style.description}>
                <Text formattedMessageValues={{ planName }} textType={TextType.H2} value={emailModalMesssages.header} />
                <Text textType={TextType.Paragraph} value={emailModalMesssages.subheader} />
                <PromotionalFeatureList billingPlanId={billingPlanId} />
                <Text textType={TextType.H4} value={emailModalMesssages.callToAction} />
              </FlexColumn>
              <FlexColumn className={style.footer}>
                <Button className={style['offer-button']} onClick={viewOfferHandler} theme={THEME_CONSTANTS.promotional}>
                  <FormattedMessage {...emailModalMesssages.button} />
                </Button>
              </FlexColumn>
            </FlexColumn>
            <FlexColumn className={style['image-section']}>
              <img alt={intl.formatMessage(emailModalMesssages.altTextForSVG)} src={StandardOrPremiumPlanFeaturesSVG} />
            </FlexColumn>
          </FlexRow>
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};
